module.exports = __webpack_public_path__ + "static/fonts/gothammedium.89dada1.woff2";